import "@fontsource-variable/assistant";
import { firebaseEnvironment } from "@repo/common";
import { AuthProvider } from "@repo/ui";
import { ThemeProvider } from "next-themes";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import * as Sentry from "@sentry/react";

Sentry.init({
	dsn: "https://1ff7bc7af5a14781f6795b06b2846bbe@o4510454344581120.ingest.us.sentry.io/4510516372766720",
	environment: firebaseEnvironment,
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
});

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<ThemeProvider
			attribute="class"
			defaultTheme="system"
			enableSystem
			disableTransitionOnChange
		>
			<AuthProvider>
				<App />
			</AuthProvider>
		</ThemeProvider>
	</StrictMode>,
);
